class Top {
  constructor(el,opt){
    this.el = el;
    this.lenis = null; // Lenisインスタンスを保存
    this.lastScrollY = 0; // 前回のスクロール位置を保存
    this.rafId = null; // requestAnimationFrameのIDを保存
    this.isDesktop = window.innerWidth >= 768; // 初期の画面サイズを判定
    this.onGsapTick = null;
    
    if($("." + this.el).length > 0){
      this.init();
    }
  }
  
  init(){
    // ScrollTriggerとLenisの統合を待つ
    this.smoothScroll();
    this.setupDrawerLenisControl();
    this.headerScrollControl(); // ヘッダーのスクロール制御を追加
    this.handleResize(); // リサイズイベントを追加
    this.event(); // 元のTopクラスのeventメソッドを実行
  }
  event(){
    const mvSwiper01 = new Swiper('.mv-swiper01', {
      loop: true,
      speed: 1000,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    const mvSwiper02 = new Swiper('.mv-swiper02', {
      loop: true, 
      speed: 1000,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    const mvSwiper03 = new Swiper('.mv-swiper03', {
      loop: true,
      speed: 1000, 
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    });

    // .js-sticky-photo要素のScrollTriggerアニメーション
    gsap.registerPlugin(ScrollTrigger);
    
    const stickyPhotos = document.querySelectorAll('.js-sticky-photo');
    
    stickyPhotos.forEach((photo) => {
      gsap.fromTo(photo, 
        {
          scale: 1,
          opacity: 1
        },
        {
          scale: 0.6,
          opacity: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: photo,
            start: "top+=300 top",
            end: "top+=1500 top", // 3画面分（約200vhの追加スクロール）
            scrub: 2 // スムーズなスクロール連動
          }
        }
      );
    });

    // .js-parallax-img要素のパララックス効果
    const parallaxImages = document.querySelectorAll('.js-parallax-img');
    
    parallaxImages.forEach((img) => {
      // レスポンシブ対応：767px以下でdata-sp-yがある場合はそちらを優先
      let moveDistance;
      const isSmallScreen = window.innerWidth <= 767;
      const spY = img.dataset.spY;
      const normalY = img.dataset.y;
      
      if (isSmallScreen && spY !== undefined) {
        moveDistance = parseInt(spY);
      } else {
        moveDistance = parseInt(normalY) || -30;
      }
      
      gsap.fromTo(img,
        {
          y: 0
        },
        {
          y: moveDistance, // 適切な値分移動
          ease: "none",
          scrollTrigger: {
            trigger: img,
            start: "top bottom", // 画面下部に入った時に開始
            end: "top top", // 画面上部を通過する時に終了
            scrub: 3, // スクロールに同期してスムーズに実行
          }
        }
      );
    });
  }

  smoothScroll(){
    // 768px以上でのみLenisを初期化
    if (this.isDesktop) {
      this.initLenis();
    }
  }

  initLenis(){
    if (typeof Lenis === 'undefined') return;

    // 二重初期化防止
    this.destroyLenis();

    this.lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      syncTouch: false,
    });

    // GSAP ticker と統合（独自 RAF との二重駆動を避ける）
    this.lenis.on('scroll', () => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.update();
      }
    });

    this.onGsapTick = (time) => {
      if (this.lenis) {
        this.lenis.raf(time * 1000);
      }
    };
    gsap.ticker.add(this.onGsapTick);
    gsap.ticker.lagSmoothing(0);

    // アンカーリンクをLenisでスクロールさせる
    this.setupAnchorLinks();
  }

  destroyLenis(){
    if (this.onGsapTick) {
      gsap.ticker.remove(this.onGsapTick);
      this.onGsapTick = null;
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
    }
  }

  setupAnchorLinks(){
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      const handleClick = (e) => {
        e.preventDefault();
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          if (this.lenis && this.isDesktop) {
            // PCの場合はLenisでスムーススクロール
            this.lenis.scrollTo(target, {
              offset: 0,
              duration: 1.5
            });
          } else {
            // モバイルの場合は通常のスクロール
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      };
      
      // 既存のイベントリスナーを削除してから新しいものを追加
      anchor.removeEventListener('click', handleClick);
      anchor.addEventListener('click', handleClick);
    });
  }

  handleResize(){
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 768;
      
      // デスクトップ⇔モバイルの切り替え時のみLenisの初期化/破棄を実行
      if (wasDesktop !== this.isDesktop) {
        if (this.isDesktop) {
          // モバイル→デスクトップ：Lenisを初期化
          this.initLenis();
          this.headerScrollControl();
        } else {
          // デスクトップ→モバイル：Lenisを破棄
          this.destroyLenis();
          this.setupNativeScrollListener();
        }
        
        // アンカーリンクの設定を更新
        this.setupAnchorLinks();
      }
    });
  }

  setupDrawerLenisControl() {
    $(document).on('click', '.js-drawer-btn', () => {
      if (this.lenis && this.isDesktop) {
        if ($('html').hasClass('is-drawer-open')) {
          this.lenis.stop();
        } else {
          this.lenis.start();
        }
      }
    });
  }

  headerScrollControl(){
    const header = document.querySelector('.js-header');
    if (!header) return;

    // PCでLenisが有効な場合はLenisのスクロールイベントを使用
    if (this.lenis && this.isDesktop) {
      this.lenis.on('scroll', (e) => {
        this.updateHeaderPosition(e.scroll);
      });
    } else {
      // モバイルまたはLenisが無効な場合は通常のスクロールイベントを使用
      this.setupNativeScrollListener();
    }
  }

  updateHeaderPosition(currentScrollY){
    const header = document.querySelector('.js-header');
    if (!header) return;

    // スクロール位置が100px以下の場合は常に表示
    if (currentScrollY <= 100) {
      header.style.transform = 'translateY(0)';
      header.style.transition = 'transform 0.3s ease';
      this.lastScrollY = currentScrollY;
      return;
    }

    // スクロール方向を判定
    if (currentScrollY > this.lastScrollY) {
      // 下にスクロール中 - ヘッダーを非表示
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.3s ease';
    } else {
      // 上にスクロール中 - ヘッダーを表示
      header.style.transform = 'translateY(0)';
      header.style.transition = 'transform 0.3s ease';
    }

    this.lastScrollY = currentScrollY;
  }

  setupNativeScrollListener(){
    if (this._nativeScrollBound) return;
    this._nativeScrollBound = true;

    const header = document.querySelector('.js-header');
    if (!header) return;

    let ticking = false;
    
    const updateHeader = () => {
      const currentScrollY = window.pageYOffset;
      this.updateHeaderPosition(currentScrollY);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
class Common {
  constructor() {
    this.lastScrollY = 0;
    this.isDesktop = window.innerWidth >= 768;
    this.init();
  }

  init() {
    this.drawerEvent();
    // トップは Top クラス側で Lenis 連動のヘッダー制御を行う
    if (!document.querySelector('.js-top')) {
      this.headerScrollControl();
    }
    this.handleResize();
  }

  drawerEvent() {
    $('.js-drawer-btn').on('click', () => {
      $('html').toggleClass('is-drawer-open');
    });
  }

  headerScrollControl() {
    const header = document.querySelector('.js-header');
    if (!header) return;
  
    let lastY = window.pageYOffset;
    let ticking = false;
    const threshold = 10; // ← スクロール方向が10px以上変化したときだけ反応
  
    const update = () => {
      const y = window.pageYOffset;
      const diff = y - lastY;
  
      // --- 閾値未満の微小なスクロールは無視 ---
      if (Math.abs(diff) < threshold) {
        ticking = false;
        return;
      }
  
      // --- スクロール位置が上端近いときは常に表示 ---
      if (y <= 100) {
        header.style.transform = 'translateY(0)';
      } else if (diff > 0) {
        // 下方向（一定以上スクロールしたときのみ隠す）
        header.style.transform = 'translateY(-100%)';
      } else {
        // 上方向
        header.style.transform = 'translateY(0)';
      }
  
      lastY = y;
      ticking = false;
    };
  
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    });
  }
  

  handleResize() {
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 768;
    });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= 769) {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

/**
 * GTranslate セレクトの挙動カスタム
 * - English（独立リンク）
 *   ・採用・インタビュー日本語 → /en/ トップ（Google翻訳は使わない）
 *   ・その他の日本語ページ → 対訳の /en/**
 * - 日本語 → /** （日本語サイト、Google翻訳解除）
 * - その他 → Google翻訳
 *   /en にいる場合は /** へ遷移してから Google翻訳を適用
 */
class GTranslateRouter {
  constructor() {
    this.bound = new WeakSet();
    this.enLinksBound = new WeakSet();
    this.translateToken = 0;
    this.trimming = false;
    this.init();
  }

  init() {
    // 日本語へ戻した直後の再適用を先に潰す
    this.enforceJapaneseIfNeeded();

    if (this.isEnSite()) {
      this.clearTranslation();
    }

    this.trimLanguageOptions();
    this.bindSelectors();
    this.bindEnglishLinks();
    this.observeSelectors();
    this.watchLanguageLabel();
    this.applyPendingTranslate();
  }

  isEnSite() {
    const path = location.pathname;
    return path === '/en' || path === '/en/' || path.startsWith('/en/');
  }

  /**
   * 採用・インタビューの日本語ページ
   * → English は対訳ではなく /en/ トップへ
   */
  isRecruitJaPage() {
    if (this.isEnSite()) return false;
    const path = location.pathname.replace(/\/+$/, '') || '/';
    return (
      path === '/graduate-recruitment' ||
      path.startsWith('/graduate-recruitment/') ||
      path === '/career' ||
      path.startsWith('/career/') ||
      path === '/interview' ||
      path.startsWith('/interview/')
    );
  }

  enHomePath() {
    return '/en/';
  }

  pathWithoutEn() {
    const path = location.pathname;
    if (path === '/en' || path === '/en/') return '/';
    if (path.startsWith('/en/')) {
      const stripped = path.replace(/^\/en/, '');
      return stripped || '/';
    }
    return path;
  }

  pathWithEn() {
    const base = this.pathWithoutEn();
    if (base === '/') return '/en/';
    return '/en' + (base.endsWith('/') ? base : base + '/');
  }

  /**
   * JP / EN は外のトグルにあるので、プルダウンは中国語2つと韓国語だけにする。
   * 英語サイトのPCでは未選択時の表示を Language にする。
   */
  trimLanguageOptions() {
    document.querySelectorAll('.gt_selector').forEach((select) => {
      select.querySelectorAll('option').forEach((opt) => {
        const value = opt.getAttribute('value') || '';
        if (value.endsWith('|en') || value.endsWith('|ja')) {
          opt.remove();
        }
      });
      if (select.value.endsWith('|en') || select.value.endsWith('|ja')) {
        select.value = '';
      }
    });
    this.labelLanguageSelects();
  }

  isPc() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  labelLanguageSelects() {
    const label = this.isEnSite() && this.isPc() ? 'Language' : '言語を選択';
    document.querySelectorAll('.gt_selector').forEach((select) => {
      const empty = select.querySelector('option[value=""]');
      if (empty && empty.textContent !== label) empty.textContent = label;
      if (select.getAttribute('aria-label') !== label) {
        select.setAttribute('aria-label', label);
      }
    });
  }

  watchLanguageLabel() {
    const mq = window.matchMedia('(min-width: 768px)');
    const onChange = () => this.labelLanguageSelects();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  /**
   * English / JP 独立リンク
   * Google翻訳は使わず、テーマ側の日英URLへ遷移する
   */
  bindEnglishLinks() {
    document.querySelectorAll('.ns-gt-nav__link, .ns-gt-nav__en').forEach((link) => {
      if (this.enLinksBound.has(link)) return;
      this.enLinksBound.add(link);
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.abortPendingTranslate();
        this.clearTranslation();
        sessionStorage.removeItem('ns_gt_pending');
        sessionStorage.removeItem('ns_gt_force_ja');

        const lang = link.getAttribute('data-ns-lang') || 'en';
        const href = link.getAttribute('href');

        if (lang === 'ja') {
          sessionStorage.setItem('ns_gt_force_ja', '1');
          this.setJapaneseLangStorage();
          location.href = href || this.pathWithoutEn();
          return;
        }

        // English: 採用系は必ず /en/ トップ、それ以外は href（対訳）優先
        if (this.isRecruitJaPage()) {
          location.href = this.enHomePath();
          return;
        }
        location.href = href || this.pathWithEn();
      });
    });
  }

  clearGoogTrans() {
    const expire = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const host = location.hostname;
    const domains = ['', host];
    const parts = host.split('.');
    // example.com / .example.com（localhost の domain= は無効なので付けない）
    if (parts.length >= 2 && parts[parts.length - 1] !== 'localhost') {
      domains.push('.' + parts.slice(-2).join('.'));
      domains.push('.' + host);
    }
    const paths = ['/', location.pathname, location.pathname.replace(/\/+$/, '') || '/'];
    const extras = ['', ';SameSite=Lax', ';SameSite=None;Secure', ';Secure'];
    paths.forEach((p) => {
      domains.forEach((domain) => {
        const domainPart = domain ? `;domain=${domain}` : '';
        extras.forEach((extra) => {
          document.cookie = `googtrans=;expires=${expire};path=${p}${domainPart}${extra}`;
        });
      });
    });
  }

  /**
   * GTranslate は url_structure=none のとき
   * localStorage.__GT_TRANSLATE_LANGS に言語を保持する。
   * クッキーだけ消すとリロード後に翻訳言語へ戻る。
   */
  clearGtLangStorage() {
    try {
      localStorage.removeItem('__GT_TRANSLATE_LANGS');
    } catch (e) {
      // ignore
    }
  }

  /**
   * 日本語を明示保存する。
   * removeItem だけだと、lib 初期化の競合で前言語が書き戻されることがある。
   */
  setJapaneseLangStorage() {
    try {
      localStorage.setItem(
        '__GT_TRANSLATE_LANGS',
        JSON.stringify({ srcLang: 'ja', tgtLang: 'ja' })
      );
    } catch (e) {
      // ignore
    }
  }

  clearTranslation() {
    this.clearGoogTrans();
    this.clearGtLangStorage();
    sessionStorage.removeItem('ns_gt_pending');
  }

  abortPendingTranslate() {
    this.translateToken += 1;
  }

  syncSelectors(langPair) {
    document.querySelectorAll('.gt_selector').forEach((select) => {
      select.value = langPair;
    });
  }

  /**
   * GTranslate lib 経由で原文に戻す（可能なら）
   * translate('ja','ja') は restore + localStorage クリアを行う
   */
  revertGoogleTranslate() {
    if (typeof window.doGTranslate === 'function') {
      try {
        window.doGTranslate('ja|ja');
      } catch (e) {
        // ignore
      }
    }
    if (window.__GT && window.__GT.translator && typeof window.__GT.translator.revert === 'function') {
      try {
        window.__GT.translator.revert();
      } catch (e) {
        // ignore
      }
    }
  }

  /**
   * 日本語選択後に中国語等が復活しないよう、リロード後も再アサートする
   */
  enforceJapaneseIfNeeded() {
    if (sessionStorage.getItem('ns_gt_force_ja') !== '1') return;

    sessionStorage.removeItem('ns_gt_force_ja');
    this.abortPendingTranslate();
    sessionStorage.removeItem('ns_gt_pending');

    const assertJa = () => {
      this.clearGoogTrans();
      this.setJapaneseLangStorage();
      this.revertGoogleTranslate();
      this.setJapaneseLangStorage();
      this.syncSelectors('');
      if (document.documentElement.lang && document.documentElement.lang !== 'ja') {
        document.documentElement.lang = 'ja';
      }
    };

    assertJa();
    setTimeout(assertJa, 100);
    setTimeout(assertJa, 500);
    setTimeout(assertJa, 1500);
  }

  hasActiveTranslation() {
    if (/(?:^|; )googtrans=/.test(document.cookie)) {
      const m = document.cookie.match(/(?:^|; )googtrans=([^;]*)/);
      if (m && m[1] && m[1] !== '/ja/ja' && m[1] !== '') return true;
    }
    try {
      const stored = JSON.parse(localStorage.getItem('__GT_TRANSLATE_LANGS'));
      if (stored && typeof stored.tgtLang === 'string' && stored.tgtLang !== 'ja') {
        return true;
      }
    } catch (e) {
      // ignore
    }
    return false;
  }

  setGoogTrans(lang) {
    const value = `/ja/${lang}`;
    document.cookie = `googtrans=${value};path=/`;
    if (location.hostname.indexOf('.') !== -1) {
      document.cookie = `googtrans=${value};path=/;domain=${location.hostname}`;
    }
  }

  navigate(path) {
    location.href = path + location.search + location.hash;
  }

  hardReloadSamePage() {
    // bfcache 回避のため replace でフル遷移
    const url = location.pathname + location.search + location.hash;
    location.replace(url);
  }

  bindSelectors() {
    document.querySelectorAll('.gt_selector').forEach((select) => {
      if (this.bound.has(select)) return;
      this.bound.add(select);
      // capture で GTranslate 本体より先に処理する
      select.addEventListener('change', (e) => this.onChange(e), true);
    });
  }

  observeSelectors() {
    const observe = () => {
      this.selectorObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    };
    this.selectorObserver = new MutationObserver(() => {
      if (this.trimming) return;
      this.trimming = true;
      this.selectorObserver.disconnect();
      this.trimLanguageOptions();
      this.bindSelectors();
      this.bindEnglishLinks();
      this.trimming = false;
      observe();
    });
    observe();
  }

  applyGoogleTranslate(lang) {
    const token = ++this.translateToken;

    // 切替前に前回の翻訳状態を消す（ko→ja→zh などで残留しないように）
    this.clearGoogTrans();
    this.setGoogTrans(lang);
    try {
      localStorage.setItem(
        '__GT_TRANSLATE_LANGS',
        JSON.stringify({ srcLang: 'ja', tgtLang: lang })
      );
    } catch (e) {
      // ignore
    }

    const tryApply = () => {
      if (token !== this.translateToken) return;
      if (typeof window.doGTranslate === 'function') {
        window.doGTranslate('ja|' + lang);
        this.syncSelectors('ja|' + lang);
        return;
      }
      setTimeout(tryApply, 200);
    };
    tryApply();
  }

  onChange(e) {
    const select = e.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!select.classList.contains('gt_selector')) return;

    const value = select.value;
    if (!value || value.indexOf('|') === -1) return;

    const targetLang = value.split('|')[1];

    // English（プルダウンに残っていた場合の保険）→ Google翻訳は使わない
    if (targetLang === 'en') {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.abortPendingTranslate();
      this.clearTranslation();
      sessionStorage.removeItem('ns_gt_force_ja');
      location.href = this.isRecruitJaPage() ? this.enHomePath() : this.pathWithEn();
      return;
    }

    // 日本語 → 日本語サイトへ（翻訳解除）
    // ※ clear だけだと DOM / cookie / storage の競合で中国語等へ戻ることがある
    if (targetLang === 'ja') {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.abortPendingTranslate();
      sessionStorage.removeItem('ns_gt_pending');
      sessionStorage.setItem('ns_gt_force_ja', '1');

      // 可能なら GTranslate 自身の restore を先に走らせる
      this.revertGoogleTranslate();
      this.clearGoogTrans();
      this.setJapaneseLangStorage();
      this.syncSelectors('');

      if (this.isEnSite()) {
        this.navigate(this.pathWithoutEn());
      } else {
        this.hardReloadSamePage();
      }
      return;
    }

    // その他 → Google翻訳
    // /en にいるときは日本語URLへ移してから翻訳
    if (this.isEnSite()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.abortPendingTranslate();
      this.clearTranslation();
      sessionStorage.removeItem('ns_gt_force_ja');
      this.setGoogTrans(targetLang);
      sessionStorage.setItem('ns_gt_pending', targetLang);
      this.navigate(this.pathWithoutEn());
      return;
    }

    // 日本語サイト上の他言語も明示的に適用
    // （採用ページで EN 翻訳後→他ページ→韓国語、などの連続切替で残留しないように）
    e.preventDefault();
    e.stopImmediatePropagation();
    sessionStorage.removeItem('ns_gt_pending');
    sessionStorage.removeItem('ns_gt_force_ja');
    this.applyGoogleTranslate(targetLang);
  }

  applyPendingTranslate() {
    if (this.isEnSite()) return;
    if (sessionStorage.getItem('ns_gt_force_ja') === '1') return;

    const pending = sessionStorage.getItem('ns_gt_pending');
    if (!pending) return;

    sessionStorage.removeItem('ns_gt_pending');
    this.applyGoogleTranslate(pending);
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).off('click').one('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBanOpen();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBanClase();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBanOpen() {
  const body = $('html')[0];
  // スクロール禁止
  scrollTop = window.scrollY;
  body.style.top = (scrollTop * -1) + 'px';
  body.classList.add('is-hidden');
}

function scrollBanClase() {
  const body = $('html')[0];
  // スクロール開放
  body.style.top = '';
  body.classList.remove('is-hidden');
  window.scrollTo(0, scrollTop);
}

// ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
window.addEventListener('load', () => {
  setTimeout(() => {
    $('.js-loading').fadeOut();
  }, 1500);
});

(() => {

  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let top = new Top('js-top');
  let common = new Common('js-header');
  let gtranslateRouter = new GTranslateRouter();
  
  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let modal = new Modal('js-modal');
  let accordion = new Accordion('js-accordion');
  let editor = new Editor('c-content');


})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});